<template>
  <div v-if="checkboxConfig">
    <template v-if="!isKcp">
      <div class="mb-3" qaid="privacy-policy-text">
        {{ $t('checkout.summary.termsAndConditions6') }}
        <pdl-link qaid="privacy-policy-link" :href="termsLink" target="_blank">
          {{ $t('page_PrivacyPolicy') }}
        </pdl-link>
      </div>
    </template>
    <pdl-form-group
      qaid="consent-checkboxes"
      class="form__fieldset mb-3"
      :disabled="false"
      error=""
      :multi-items="items"
      name="termsAndConditionsCheckboxes"
      :required="true"
      show-label
      type="checkbox"
      :label-classes="'text-sm'"
      :warning="false"
      @change.stop="handleCheck"
    />
  </div>
</template>

<script>
import {mapState} from 'vuex';
import {PdlFormGroup} from '@pedal/pdl-form-group';
import CheckboxConfiguration from '@/modules/consent-checkboxes';
import {PdlLink} from '@pedal/pdl-link';
import {useIsTranslationLoaded} from '@/composables/is-translation-loaded.js';

const TERMS_CHECKED_EVENT = 'requiredTermsChecked';

export default {
  components: {PdlFormGroup, PdlLink},
  data: () => {
    return {
      checkboxConfig: undefined,
    };
  },
  computed: {
    ...mapState('backend', ['locale', 'encodedContextPath']),
    items() {
      return this.checkboxConfig?.getCheckboxList();
    },
    isKcp() {
      return this.locale === 'kr';
    },
    termsLink() {
      return `${this.encodedContextPath}/company/legal_policies/privacy_policy_terms_of_use/`;
    },
  },
  created() {
    useIsTranslationLoaded(() => {
      this.checkboxConfig = CheckboxConfiguration(this.locale).getRegistrationConfiguration();
      if (this.checkboxConfig.getIsEmpty()) this.$emit(TERMS_CHECKED_EVENT, true);
    });
  },
  methods: {
    handleCheck(ev) {
      if (ev.srcElement.name === 'allTermsCheck') {
        this.checkboxConfig?.toggleAll();
      } else {
        this.checkboxConfig?.toggleCheckbox(ev.srcElement.name);
      }
      this.$emit(TERMS_CHECKED_EVENT, this.checkboxConfig.getIsAllRequiredChecked());
    },
  },
};
</script>
